// extracted by mini-css-extract-plugin
export default {"subTitle":"JP_Management_subTitle__EGGkK","title":"JP_Management_title__eI8R0","backgroundImg":"JP_Management_backgroundImg__owgZA"};